import type { Turn } from '@/stores/useInterviewStore'
import { cn } from '@/lib/utils'
import ReactMarkdown from 'react-markdown'
import { ThinkingBlock } from './ThinkingBlock'

interface ChatMessageProps {
  turn: Turn
}

export function ChatMessage({ turn }: ChatMessageProps) {
  const isUser = turn.role === 'user'

  return (
    <div
      className={cn(
        'flex',
        isUser ? 'justify-end' : 'justify-start'
      )}
    >
      <div
        className={cn(
          'max-w-[85%]',
          isUser
            ? 'rounded-lg px-4 py-3 bg-foreground text-background'
            : 'pl-4 border-l-2 border-foreground/10 py-3'
        )}
      >
        {/* Collapsed thinking block for assistant messages */}
        {!isUser && turn.thinking && (
          <ThinkingBlock thinking={turn.thinking} isStreaming={false} />
        )}

        {isUser ? (
          <div className="prose-chat-user text-sm max-w-none [&_*:last-child]:mb-0 [&_p]:mb-2">
            <ReactMarkdown>{turn.content.trim()}</ReactMarkdown>
          </div>
        ) : (
          <div className="prose-chat text-sm min-h-0 [&_*:last-child]:mb-0">
            <ReactMarkdown>{turn.content.trim()}</ReactMarkdown>
          </div>
        )}
        <div
          className={cn(
            'text-[10px] mt-1.5 font-light tracking-wide',
            isUser ? 'text-background/50' : 'text-muted-foreground/70'
          )}
        >
          {new Date(turn.timestamp).toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
          })}
        </div>
      </div>
    </div>
  )
}
